import React from 'react';
import AboutDetail from '../components/about-details';
import AboutData from '../components/about-data';
import AboutLead from '../components/about-lead';
// import ComingSoon from '../components/comingSoon';
import usePageMeta from '../hooks/usePageMeta';

export default function About() {
    usePageMeta('About Spinnennetz | AI-Driven CRO Experts for eCommerce', 'Meet Spinnennetz — a CRO agency using AI-assisted testing and data-driven design to help eCommerce brands convert more visitors into paying customers.', '/about-us', {"@context":"https://schema.org","@type":"AboutPage","name":"About Spinnennetz","description":"A CRO agency using AI-assisted testing and data-driven design to help eCommerce brands convert more visitors into paying customers."});
    return (
        <>
            <AboutDetail />
            <AboutData />
            <AboutLead />
            {/* <ComingSoon /> */}
        </>
    );
}
